export default "__VITE_ASSET__813df1f2__"